import { defineStore } from 'pinia'
import { useAuthStore } from '@/auth/auth'
import { ApiSup } from "@/Functions/ApiSupport";

export const useSchoolStore = defineStore('schoolStore', {
  state: () => ({
    schools: [],
    school: {},
  }),
  actions: {
    async addSchool(school) {

      const authStore = useAuthStore()
      try {
       // const res = await fetch('http://localhost:8080/api/schools/', {
        const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/schools/`, {
          method: 'POST',
          body: JSON.stringify(school),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authStore.token}`,
          }
        })
        this.fetchData()
        const result = await res.json()
        console.log(result)

        if (!res.ok) {
          // console.error('Server error:', result)
          return { success: false, data: result }
        }

        return { success: true, data: result }
      } catch (error) {
        // console.error('Network error:', error)
        console.log(error.message)
        return { success: false, message: error.message }
      }

    },

    async fetchData() {
      const authStore = useAuthStore()
      //const res = await fetch('http://localhost:8080/api/schools/')
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/schools/`, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        }
      })
      const data = await res.json()

      // this.schools = Object.fromEntries(data.data.map((school) => [school.pid, school]))
      this.schools = data.data
    },

async fetchDataWithParams(school,division) {
  const authStore = useAuthStore()
  const url = new URL(`${import.meta.env.VITE_HOST_API}/api/schools`)
    url.searchParams.append('school_level', school || '')
    url.searchParams.append('school_division', division || '')

  const res = await fetch(url.toString(), {
    headers: {
      Authorization: `Bearer ${authStore.token}`,
    }
  })
  const data = await res.json()
  this.schools = data.data
},

    //for dropdown
    async fetchSchoolList(){
      const authStore = useAuthStore()
      //const res = await fetch('http://localhost:8080/api/schools/')
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/schools/`,{
       headers: {
          Authorization: `Bearer ${authStore.token}`
        }}
      )
      const data = await res.json()

      this.schools = Object.fromEntries(data.data.map((school) => [school.pid, school]))
      this.schools = data.data
      return this.schools
    },

    async fetchByID(pid) {
      const authStore = useAuthStore()
     // const res = await fetch('http://localhost:8080/api/schools/' + pid)
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/schools/` + pid,{
        headers:{
          Authorization: `Bearer ${authStore.token}`
        }
      })
      const data = await res.json()
      this.school = data.data

    },
    async deleteSchool(id){
      const apiSup = ApiSup()
      const ret = await apiSup.deleteSupport('api/schools/' + id)
       if (ret === 'success'){
        await this.fetchData()
        return { success: true }
      }else{
        return {success: false}
      }

    },

    async updateSchool(school, pid){
      try {
        const authStore = useAuthStore()
        //const res = await fetch('http://localhost:8080/api/schools/' + pid, {
        const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/schools/` + pid, {
          method: 'PUT',
          body: school,
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authStore.token}` },
        })
        this.fetchData()
        if (!res.ok) {
          const errorData = await res.json()
        }
        else{
          return { success: true, data: res };
        }

      } catch (error) {
          return { success: false, message: error.message };
      }

    }
  },
  getters: {
    getSchoolById: (state) => (pid) => {
      // alert(pid)
      return state.schools.find((school) => school.pid === pid) || null
    },
  },
  // persist: true
})
